var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8694,
    cy: 13,
    r: 12.6087,
    fill: "#F3F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7879 13.2917C18.7879 10.1466 16.2531 7.59644 13.1269 7.59644C10.0007 7.59644 7.46582 10.1466 7.46582 13.2917C7.46582 16.1342 9.53564 18.4904 12.2423 18.918V14.9385H10.8046V13.2917H12.2423V12.0369C12.2423 10.6098 13.0877 9.82088 14.3806 9.82088C15.0001 9.82088 15.6481 9.93225 15.6481 9.93225V11.3339H14.9338C14.231 11.3339 14.0111 11.7728 14.0111 12.2238V13.2917H15.5811L15.3304 14.9385H14.0114V18.9185C16.7181 18.4911 18.7879 16.135 18.7879 13.2917Z",
    fill: "#064A72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30);
export default __webpack_public_path__ + "static/media/Group 30.4bdcacfb95d3a9392adf64ecb5a5f7f6.svg";
export { ForwardRef as ReactComponent };